module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag2.9d82aefe.gif";